import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiServices extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "services";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  updaters = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/updaters`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Execução de serviços (updaters)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiServices;
